import { createApi } from '@reduxjs/toolkit/query/react';
import EnhancedBaseQuery from '../../Api/createApiConfig';

const emailApi = createApi({
    reducerPath: 'emailApi',
    baseQuery: EnhancedBaseQuery,
    endpoints: () => ({}),
});

const injectedEmailApi = emailApi.injectEndpoints({
    endpoints: (builder) => ({
        emailList: builder.mutation({
            query: () => ({
                url: '/RequestedNewMailList',
                method: 'GET',
            }),
        }),
        requestEmail: builder.mutation({
            query: (data) => ({
                url: '/RequestForNewMail',
                method: 'POST',
                body: data,
            }),
        }),
        requestApprove: builder.mutation({
            query: (data) => ({
                url: '/ApproveRequestForNewMail',
                method: 'POST',
                body: data,
            }),
        }),
    }),
    overrideExisting: false,
});
export const {
    useEmailListMutation,
    useRequestEmailMutation,
    useRequestApproveMutation,
} = injectedEmailApi;
export default emailApi;
